import {Component, input} from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
  selector: 'loading-spinner',
  standalone: true,
  imports: [
    NgStyle
  ],
  template: `
    <div class="animate-spin border-4 border-gray-200 border-t-red-600 rounded-full"
         [ngStyle]="{'width': size(), 'height': size() }"></div>`
})
export class LoadingSpinnerComponent {
  size = input('3rem');
}
